import { Link } from 'react-router-dom';
import { useContext } from "react";

function Footer() {
    return (
        <div className='footer'>
            <p>Nic Solitom © 2022</p>
        </div>
    )
}

export default Footer;